<template>
  <div class="h-full modal w-full">
    <div class="modal-content">
      <h1
        class="w-full mb-6 text-xl font-semibold tracking-wide text-gray-800 uppercase"
      >
        {{ $t('components.company.contactAcquisitionDetails.title') }}
      </h1>
      <div class="justify-flex-start flex flex-wrap wrapper">
        <div class="table-wrapper p-4 border rounded-lg shadow bg-white">
          <h2>{{ $t('components.company.contactAcquisitionDetails.invitations') }}</h2>
          <table class="w-full text-sm mt-4">
            <tbody class="text-gray-800">
              <tr
                v-for="(row, index) in invitationsPerLandingpage"
                :key="index"
                class="border-t border-gray-200"
              >
                <td
                  class="py-2"
                >
                  {{ row.label }}
                </td>
                <td
                  class="text-right font-medium"
                >
                  {{ row.value?.toLocaleString() || 0 }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-wrapper p-4 border rounded-lg shadow bg-white">
          <h2>{{ $t('components.company.contactAcquisitionDetails.topics') }}</h2>
          <table class="w-full text-sm mt-4">
            <tbody class="text-gray-800">
              <tr
                v-for="(row, index) in topicStatistics"
                :key="index"
                class="border-t border-gray-200"
              >
                <td
                  class="py-2"
                >
                  {{ row.label }}
                </td>
                <td
                  class="text-right font-medium"
                >
                  {{ row.value?.toLocaleString() || 0 }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-wrapper p-4 border rounded-lg shadow bg-white">
          <h2>{{ $t('components.company.contactAcquisitionDetails.contents') }}</h2>
          <table class="w-full text-sm mt-4">
            <tbody class="text-gray-800">
              <tr
                v-for="(row, index) in textKindStatistics"
                :key="index"
                class="border-t border-gray-200"
              >
                <td
                  class="py-2"
                >
                  {{ row.label }}
                </td>
                <td
                  class="text-right font-medium"
                >
                  {{ row.value?.toLocaleString() || 0 }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        class="btn-inline"
        @click="$emit('close')"
      >
        {{ $t('common.cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import GET_CREATED_CONTENTS_STATISTICS from '@/components/company/queries/GetCreatedContentsStatistics.gql'
import { ReadableKindType } from '@/components/company/enums/KindType'

export default {
  props: {
    items: {
      type: Object,
      default: () => ({})
    },
    invitationsPerLandingpage: {
      type: Array,
      default: () => ([])
    },
    companyId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      textKindStatistics: [],
      topicStatistics: []
    }
  },
  apollo: {
    statistics: {
      query: GET_CREATED_CONTENTS_STATISTICS,
      variables () {
        return {
          input: {
            companyId: this.companyId
          }
        }
      },
      skip () {
        return !this.companyId
      },
      fetchPolicy: 'cache-and-network',
      update (data) {
        if (data.statistics) {
          this.textKindStatistics = data.statistics.textKindStatistics?.map((contentType) => {
            return {
              label: ReadableKindType[contentType.textKind] || contentType.textKind || 'Unbekannt',
              value: contentType.count || 0
            }
          })
          this.topicStatistics = data.statistics.topicStatistics.map((contentType) => {
            return {
              label: contentType.topicName || 'Unbekannt',
              value: contentType.count || 0
            }
          })
        }
        return data.statistics
      }
    }
  }
}
</script>
<style scoped>
.table-wrapper table {
  height: auto;
}
.wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1rem;
}
.table-wrapper {
  flex: 0 0 320px;
}
</style>
